import React, { useEffect } from 'react';
import { useClient } from 'jsonapi-react';
import { useNavigate } from 'react-router-dom';
import { Loader } from '@/components/custom/loader';
import { PATHS } from '@/routes/paths';

// /trilha/atual: abre o último capítulo da trilha acessada por último (GET /trails já vem
// nessa ordem) e redireciona para /trilha/:trailId/:chapterId. Sem trilha, volta para a lista.
export function LearningPathCurrent() {
  const client = useClient();
  const navigate = useNavigate();

  useEffect(() => {
    let mounted = true;
    client.fetch('trails').then(response => {
      if (!mounted) return;
      const trail = response?.data?.[0];
      const target = trail ? PATHS.LEARNING_PATH.CHAPTER(trail.id, trail['latest-chapter-id']) : PATHS.LEARNING_PATH.ROOT;
      navigate(target, { replace: true });
    });
    return () => {
      mounted = false;
    };
  }, [client, navigate]);

  return <Loader />;
}
